import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/DBContext';
import { List, Avatar, Typography, Card, Tooltip, Button, Popconfirm, message } from 'antd';
import { UserOutlined, CalendarOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

const CommentItem = ({ name, date, text, isAdmin, onDelete }) => (
  <List.Item
    actions={isAdmin ? [
      <Popconfirm
        title="Delete Comment"
        description="Are you sure you want to delete this comment?"
        onConfirm={onDelete}
        okText="Yes"
        cancelText="No"
      >
        <Button 
          type="text" 
          danger 
          icon={<DeleteOutlined />}
        >
          Delete
        </Button>
      </Popconfirm>
    ] : []}
  >
    <List.Item.Meta
      avatar={<Avatar icon={<UserOutlined />} />}
      title={<Text strong>{name}</Text>}
      description={
        <Tooltip title={`Commented on ${date}`}>
          <Paragraph>{text}</Paragraph>
        </Tooltip>
      }
    />
  </List.Item>
);

const Comments = ({ blogId }) => {
  const { fetchCommentsForBlog, deleteBlogComment, userInfo } = useAuth();
  const [comments, setComments] = useState([]);

  useEffect(() => {
    let unsubscribe = fetchCommentsForBlog(blogId, (fetchedComments) => {
      setComments(fetchedComments.map(comment => ({
        ...comment,
        date: new Date(comment.timestamp.seconds * 1000).toLocaleDateString()
      })));
    });

    // Check if unsubscribe is a function before calling it
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [blogId, fetchCommentsForBlog]);

  const handleDeleteComment = async (commentId) => {
    try {
      await deleteBlogComment(blogId, commentId);
      message.success('Comment deleted successfully');
    } catch (error) {
      console.error('Error deleting comment:', error);
      message.error('Failed to delete comment');
    }
  };

  return (
    <Card bordered={false}>
      {/* <Typography.Title level={4}>Comments ({comments.length})</Typography.Title> */}
      <List
        itemLayout="horizontal"
        dataSource={comments}
        renderItem={comment => (
          <CommentItem
            key={comment.id}
            name={comment.author}
            date={comment.date}
            text={comment.text}
            isAdmin={userInfo?.role === 'admin'}
            onDelete={() => handleDeleteComment(comment.id)}
          />
        )}
      />
    </Card>
  );
};

export default Comments;